import { SET_VIEWPORT, SET_VIEWPORT_OVERLAY, SET_VIEWPORT_TITLE } from 'reducers/actions-types';

export default Object.freeze({
    setViewport({ width, height, mq }) {
        return { type: SET_VIEWPORT, width, height, mq };
    },
    setTitle({ title }) {
        return { type: SET_VIEWPORT_TITLE, title };
    },
    setOverlay({ hasOverlay }) {
        return { type: SET_VIEWPORT_OVERLAY, hasOverlay };
    },
});



// WEBPACK FOOTER //
// ./mcart/assets/src/js/app/reducers/modules/viewport/actions.js